import { useDispatch } from "react-redux";
import { setTrainingName } from "../app/slices/TrainingSlice";

export const UpdateTrainingName = () => {
  const dispatch = useDispatch();

  const updateCourse = (newName: string) => {
    dispatch(setTrainingName(newName));
  };

  return [updateCourse] as const;
};
